// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

//引入element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

//引入公共方法
import tools from './tools'

//引入api
import {api} from './request/api'

// 简单状态管理
import store from "./store";

// 引入上传sdk


// <script src="lib/aliyun-upload-sdk/lib/es6-promise.min.js"></script>
//   <script src="lib/aliyun-upload-sdk/lib/aliyun-oss-sdk-5.3.1.min.js"></script>
//   <script src="lib/aliyun-upload-sdk/aliyun-upload-sdk-1.5.0.min.js"></script>


Vue.use(ElementUI);
Vue.use(tools);

Vue.prototype.$api = api;
Vue.prototype.store = store;

Vue.config.productionTip = false;

// console.log(process.env.NODE_ENV);
/* eslint-disable no-new */
let _that = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});
// 导出vue实例  在js工具模块中使用 进行路由跳转
export default _that



// WEBPACK FOOTER //
// ./src/main.js